export default __webpack_public_path__ + "static/media/Centrifuge_Rotor_Adapters.38f6b1ab.svg";